import { Dictionary, groupBy } from 'lodash';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ErpObject, SelectedPosition } from '../../types';
import { ErpDialogGroupedPositions } from '../ErpDialogArticleGroupedPositions/ErpDialogGroupedPositions';
import { groupByArticle } from '../ErpDialogArticleGroupedPositions/groupByArticle';
import { useGroupByArticleQuery } from '../ErpDialogArticleGroupedPositions/use-group-by-article-query';
import { ErpDialogPositionsProps } from '../ErpDialogPositions';

interface ErpDialogSupplierGroupedPositions
  extends Omit<ErpDialogPositionsProps, 'entry' | 'title'> {
  data: ErpObject[];
  positionPatch: SelectedPosition[];
  isEditMode: boolean;
}
export const ErpDialogSupplierGroupedPositions = (
  props: ErpDialogSupplierGroupedPositions
) => {
  const { sourceEntity, positionPatch, isEditMode } = props;

  const { t } = useTranslation();
  const {
    erpData: { data, refetch },
  } = useGroupByArticleQuery({
    data: props.data,
    sourceEntity,
    positionPatch,
    groupByType: props.groupByType,
    isEditMode,
  });

  const [groupedPositionList, setGroupedPositionList] = useState<
    Dictionary<ReturnType<typeof groupByArticle>>
  >({});
  useEffect(() => {
    if (data.length) {
      const positionList = groupByArticle(data);
      const groups = groupBy(positionList, 'supplierId');
      setGroupedPositionList(groups);
    }
  }, [data]);

  return Object.entries(groupedPositionList).map(
    ([_supplierId, positionList], idx) => {
      const title = (() => {
        const supplierName = positionList[0].supplier?.name;
        const supplierNumber = positionList[0].supplier?.number;
        if (supplierName || supplierNumber) {
          return [supplierNumber, supplierName].filter(Boolean).join(' | ');
        }
        return t('COMMON.ERP.GROUP_WITHOUT_SUPPLIER');
      })();

      return (
        <ErpDialogGroupedPositions
          showTableHeader={idx === 0}
          supplierId={_supplierId}
          title={title}
          {...props}
          positionList={positionList}
          isEditMode={isEditMode}
          allData={data}
          onRefetch={refetch}
        />
      );
    }
  );
};
